import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {useIntegrationStatus} from '../../../hooks/useIntegrationStatus';
import {OnboardingStepKeyEnum, PMTOOLS_PROVIDER_ORDER, type RoadmapStep} from '../types';
import {DashboardStatus} from '../../../constants/integrationTypes';

export function useOnboardingRoadmap() {
  const { onboardSettings = {} } = useSelector((state: any) => state.organization);
  const { isIntegrationActive } = useIntegrationStatus();
  const { roadmaps = [] } = useSelector((state: any) => state.roadmap || {});
  const hasAtRiskRoadmaps = useMemo(() => Array.isArray(roadmaps) && roadmaps.some((r: any) => String(r?.status || '').toLowerCase() === DashboardStatus.AT_RISK), [roadmaps]);

  const steps: RoadmapStep[] = useMemo(() => {
    const azureActive = isIntegrationActive('azure');
    const jiraActive = isIntegrationActive('jira');

    const pmToolsObj = (onboardSettings?.pm_tools || {}) as Record<string, boolean>;
    const allPmToolsCompleted = PMTOOLS_PROVIDER_ORDER.every((k) => pmToolsObj?.[k] === true);

    const riskObj = (onboardSettings?.risk_mitigation || {}) as Record<string, boolean>;

    return [
      { key: OnboardingStepKeyEnum.RiskMitigation, done: riskObj?.awareness && riskObj?.analyze, include: hasAtRiskRoadmaps },
      { key: OnboardingStepKeyEnum.PmTools, done: allPmToolsCompleted, include: true },
      { key: OnboardingStepKeyEnum.ImportUsers, done: !!onboardSettings.import_users, include: azureActive || jiraActive },
      { key: OnboardingStepKeyEnum.Integrations, done: !!onboardSettings.import_teams, include: azureActive },
      { key: OnboardingStepKeyEnum.OrgSkills, done: !!onboardSettings.org_skills, include: true },
      { key: OnboardingStepKeyEnum.AllocateSkills, done: !!onboardSettings.allocate_skills, include: true },
      { key: OnboardingStepKeyEnum.OrgHolidays, done: !!onboardSettings.org_holidays, include: true },
    ];
  }, [onboardSettings, isIntegrationActive, hasAtRiskRoadmaps]);

  const included = useMemo(() => steps.filter(s => s.include), [steps]);
  const current = useMemo(() => included.find(s => !s.done)?.key, [included]);

  const isCurrent = (key: OnboardingStepKeyEnum) => current === key;

  return { steps, currentStepKey: current, isCurrent };
}

export default useOnboardingRoadmap; 